// 공연 포스터 이미지 해석 헬퍼
// -----------------------------------------------------------------------------
// DB events.image 값은 세 가지 형태 중 하나다:
//   (a) 업로드된 파일 경로 ("/uploads/events/...") 또는 외부 URL ("http...")
//   (b) 기존 8건이 쓰던 imageMap 키 문자열 (img1~img5, salondemusique_20211204 등)
//   (c) 빈 문자열 / null / 알 수 없는 키
// resolveEventImage 는 (a)(b) 는 실제 표시 가능한 URL 을, (c) 는 null 을 돌려준다.
// null 인 경우 호출부는 img2 등으로 대체하지 말고 플레이스홀더를 렌더해야 한다.
// -----------------------------------------------------------------------------

// 기존 최적화 WebP 포스터 (Events.js 에서 이관)
import img1 from './../images/web/events/capture.webp';
import img4 from './../images/web/events/20231022_sammo.webp';
import salondemusique_20211204 from './../images/web/events/20211204_salondemusique.webp';
import img2 from './../images/web/events/homecoming-recital.webp';
import img3 from './../images/web/events/kakao-20230826.webp';
import img5 from './../images/web/events/20231014_salondemusique.webp';
import praum20231122 from './../images/web/events/20231122_praum.webp';

export const imageMap = {
   img1,
   img2,
   img3,
   img4,
   img5,
   salondemusique_20211204,
   praum20231122,
};

// image 값을 실제 표시 URL 로 해석. 알 수 없으면 null.
export const resolveEventImage = (image) => {
   if (!image || typeof image !== 'string') return null;
   const val = image.trim();
   if (!val) return null;
   if (val.startsWith('/uploads/') || val.startsWith('http://') || val.startsWith('https://')) {
      return val;
   }
   if (Object.prototype.hasOwnProperty.call(imageMap, val)) {
      return imageMap[val];
   }
   return null;
};
